<template>
  <div>
    <b-modal id="show-modal-confirmacao-lancamento" 
             centered
             size="lg"
             header-bg-variant="secondary"
             header-text-variant="white">
      <span class="h5">{{ `Tem certeza que deseja excluir ${propItensHabilitados.length === 1? "esse lançamento?" : "esses lançamentos?"}` }}</span><br>
      <template v-slot:modal-footer="{ close }">
        <button type="button"
                class="btn btn-close-modal pl-4 pr-4"
                @click="close()">
          Voltar
        </button>
        <button type="button"
                class="btn btn-secondary"
                @click="fecharModal(close, $bvModal)">
          Continuar
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'ConfirmacaoExclusaoLancamento',
    props: {
      propItensHabilitados: {
        type: Array,
        default: null
      }
    },
    methods: {
      fecharModal (close, modal) {
        this.$emit('verificar', modal)
        close()
      }
    }
  }
</script>

<style>

</style>
